import * as React from "react";
import { useEffect, useState } from "react";
import "./MaxDistanceInput.scss";
import ToggleButton from "../commons/components/buttons/ToggleButton";

interface PatientPracticeSelectionInputProps {
  patientCanSelectPractice: boolean;
  onValueChange: (newPatientPracticeSelection: boolean) => void;
}

const PatientPracticeSelectionInput = (props: PatientPracticeSelectionInputProps) => {
  const [patientCanSelectPractice, setPatientPracticeSelection] = useState(
    props.patientCanSelectPractice
  );

  useEffect(() => {
    props.onValueChange(patientCanSelectPractice);
  }, [patientCanSelectPractice]);

  return (
    <div className="h-flex">
      <div className="practice-choice-input">
        <ToggleButton
          value={patientCanSelectPractice}
          onChange={(toggleInput) => setPatientPracticeSelection(toggleInput)}
        />
      </div>
    </div>
  );
};

export default PatientPracticeSelectionInput;
